import React, { ReactElement } from "react";
import Head from "next/head";
import { Variables } from "@page-builder/ts/types";
import { useDomainContext } from "@hooks/useDomainContext";
import { extractUrl } from "@page-builder/utils";
import { Variable } from "@page-builder/ts/generated";

export default function MainSectionBgPreload({
    variables = {},
}: {
    variables?: Variables;
}): ReactElement {
    const { visitDetails } = useDomainContext();
    let src: string | undefined = "";

    const bg = variables.backgroundImage as Variable | undefined;

    if (typeof bg === "string") {
        src = bg;
    } else {
        if (
            visitDetails.platform === "mobile" ||
            visitDetails.platform === "wearable"
        ) {
            src = bg?.sm ?? "";
        } else if (visitDetails.platform === "tablet") {
            src = bg?.md ?? bg?.sm ?? "";
        } else {
            src = bg?.lg ?? bg?.xl ?? bg?.md ?? bg?.sm ?? "";
        }
    }

    const imageUrl = src ? extractUrl(src) : "";

    if (!imageUrl) {
        return <></>;
    }

    return (
        <Head>
            <link rel="preload" as="image" href={imageUrl} />
        </Head>
    );
}
